import { c as _c } from "react/compiler-runtime";
import Svg, { type SvgProps } from '../../Svg';

/**
 * Remove Icon from Figma
 * @link [Figma](https://www.figma.com/design/bUeKiC8YcV9PHrMlJAZUJG/Design-System?node-id=3994-10680&node-type=symbol&m=dev)
 * */

const LockIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g><path d="M3.5 5V3.125C3.5 2.42881 3.76339 1.76113 4.23223 1.26884C4.70107 0.776562 5.33696 0.5 6 0.5C6.66304 0.5 7.29893 0.776562 7.76777 1.26884C8.23661 1.76113 8.5 2.42881 8.5 3.125V5M6 7.5V9M2.72727 5H9.27273C9.27273 5 10 5 10 5.72222V10.7778C10 10.7778 10 11.5 9.27273 11.5H2.72727C2.72727 11.5 2 11.5 2 10.7778V5.72222C2 5.72222 2 5 2.72727 5Z" className="stroke-current" strokeLinecap="round" strokeLinejoin="round" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <Svg width={12} height={12} {...props}>{t0}</Svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default LockIcon;